import React, {Component} from "react";
import {ACCOUNT, HOME, MESSAGES, SIGN_OUT} from "../../constants/routes";
import {connect} from "react-redux";
import MediaQuery from "react-responsive";
import {
    BOOTSTRAP_MAX_MD, BOOTSTRAP_MAX_XS, BOOTSTRAP_MIN_MD,
    BOOTSTRAP_MIN_XS
} from "../../constants/bootstrapResponsive";
import NavbarAuthUnitDropdown from "./NavbarAuthUnitDropdown";
import {Link} from "react-router-dom";
import {googleMapURL} from "../../constants/googleMaps";
import {urlLogo} from "../../constants/asseturls";
import {slide as RightMenu} from 'react-burger-menu';
import {byPropKey} from "../utils";

/**
 * Version of the navbar that is displayed when an authenticated user is signed in.
 */
class NavbarAuth extends Component {
    constructor() {
        super();
        this.state = {
            isMobileRightMenuOpen: false
        };
    }

    /**
     * Closes the mobile menu on the right.
     */
    closeMobileMenu = () => {
        this.setState(byPropKey('isMobileRightMenuOpen', false));
    };

    render() {
        return (
            <div className="container">
                <MediaQuery maxWidth={BOOTSTRAP_MAX_XS}>
                    <NavbarAuthUnitDropdown
                        mobile
                        googleMapURL={googleMapURL}
                        loadingElement={<div/>}
                    />
                </MediaQuery>
                <Link className="navbar-brand" to={HOME}><img className="logoStyle" src={urlLogo} alt="AutoI" /></Link>
                <MediaQuery maxWidth={BOOTSTRAP_MAX_XS}>
                    <RightMenu isOpen={this.state.isMobileRightMenuOpen} className={"right-menu"} right>
                        <a className="nav-link text-white">
                            {this.props.authUser.displayName && 'Welcome, ' + this.props.authUser.displayName}
                        </a>
                        <Link onClick={this.closeMobileMenu} className="bm-menu-item" to={HOME}>
                            <i className="fas fa-home"/> Home
                        </Link>
                        <Link onClick={this.closeMobileMenu} className="bm-menu-item" to={MESSAGES}>
                            <i className="fas fa-bell"/> Your Notifications
                        </Link>
                        <Link onClick={this.closeMobileMenu} className="bm-menu-item" to={ACCOUNT}>
                            <i className="fas fa-cog"/> Your Account
                        </Link>
                        <Link onClick={this.closeMobileMenu} className="bm-menu-item" to={SIGN_OUT}>
                            <i className="fas fa-sign-out-alt"/> Sign Out
                        </Link>
                    </RightMenu>
                </MediaQuery>
                <MediaQuery minWidth={BOOTSTRAP_MIN_XS}>
                    <div className="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item">
                                <Link to={ACCOUNT} className="nav-link text-white">
                                    {
                                        this.props.authUser.displayName &&
                                        'Welcome, ' + this.props.authUser.displayName
                                    }
                                </Link>
                            </li>
                            <NavbarAuthUnitDropdown
                                googleMapURL={googleMapURL}
                                loadingElement={<div/>}
                            />
                        </ul>
                        <ul className="navbar-nav">
                            <MediaQuery minWidth={BOOTSTRAP_MIN_XS} maxWidth={BOOTSTRAP_MAX_MD}>
                                <li className="nav-item text-center">
                                    <Link className="nav-link" to={MESSAGES}>
                                        <i className="fas fa-bell fa-lg"/>
                                    </Link>
                                </li>
                                <li className="nav-item text-center">
                                    <Link className="nav-link" to={ACCOUNT}>
                                        <i className="fas fa-cog fa-lg"/>
                                    </Link>
                                </li>
                                <li className="nav-item text-center">
                                    <Link className="nav-link" to={SIGN_OUT}>
                                        <i className="fas fa-sign-out-alt fa-lg"/>
                                    </Link>
                                </li>
                            </MediaQuery>
                            <MediaQuery minWidth={BOOTSTRAP_MIN_MD}>
                                <li className="nav-item text-center">
                                    <Link className="nav-link" to={MESSAGES}>
                                        <i className="fas fa-bell fa-lg"/>
                                        <div>Notifications</div>
                                    </Link>
                                </li>
                                <li className="nav-item text-center">
                                    <Link className="nav-link" to={ACCOUNT}>
                                        <i className="fas fa-cog fa-lg"/>
                                        <div>Account</div>
                                    </Link>
                                </li>
                                <li className="nav-item text-center">
                                    <Link className="nav-link" to={SIGN_OUT}>
                                        <i className="fas fa-sign-out-alt fa-lg"/>
                                        <div>Sign Out</div>
                                    </Link>
                                </li>
                            </MediaQuery>
                        </ul>
                    </div>
                </MediaQuery>
            </div>
        );
    }
}

/**
 * Map Redux {@param state} to component props
 */
const mapStateToProps = (state) => ({
    authUser: state.sessionState.authUser
});

export default connect(mapStateToProps)(NavbarAuth);



// WEBPACK FOOTER //
// ./src/components/navigationbar/NavbarAuth.jsx